// Must stay the first import: a dev-login link stores its session before anything reads it.
import "./devLogin";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import "./index.css";
import "./carbon.scss";
import App from "./App";
import { Error } from "./containers";
import "./i18n";
import { AppProvider } from "./context/AppProvider";
import "@copilotkit/react-ui/styles.css";

const queryClient = new QueryClient();

const container = document.getElementById("app");

if (container) {
  const root = createRoot(container as HTMLElement);

  const app = (
    <AppProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary FallbackComponent={Error}>
            <App />
          </ErrorBoundary>
        </QueryClientProvider>
      </BrowserRouter>
    </AppProvider>
  );

  root.render(app);
} else {
  console.error("No root container found");
}
